module.exports = __webpack_public_path__ + "img/icon-download-app.21b0545e.png";